import { BuildingAttrKeys } from './building-attr-keys.js';

const UserDefinedAttributesList = [
    BuildingAttrKeys.Generator,
    BuildingAttrKeys.Sprinklered,
    BuildingAttrKeys.DistrictHeating,
    BuildingAttrKeys.EnergyCentre,
    BuildingAttrKeys.CentralASHP,
    BuildingAttrKeys.City
];

export { UserDefinedAttributesList };
//# sourceMappingURL=user-defined-building-attributes-list.js.map
